/* eslint-disable react/prop-types */
import classes from './SubServPart.module.scss';
import { GrFormNextLink } from "react-icons/gr";



const Card = ({title , description , img , lang })=>{
    return (

        <div className={classes["room__card"]}>
            <div className={classes["room__card__image"]}>
                <img src={img} alt="product" loading="lazy"/>
            </div>
            <div className={`${classes["room__card__details"]} ${lang === 'ar'&&classes.ar_text_2}`}>
                <h4>{title}</h4>
                <p>{description}</p>
            </div>
        </div>

    )
}

function SubServPart({products , title , overview , lang ,path}) {
    const content = {
        en: {
            title: 'Features & Benefits',
            buttonText: 'Request a Free Demo',
        },
        ar: {
            title: 'الميزات والفوائد',
            buttonText: 'اطلب عرض تجريبي مجاني',
        }
    };
    return (
        <section className={`${classes["room__container"]} ${classes["section__container"]}`}>
            <h1 className={`${classes["heading_sec"]} ${lang === 'ar'&&classes.ar_text}`} >{content[lang].title}</h1>
            <div className={classes["room__grid"]}>
                {products.map((ele,i)=>{
                    return((<Card  key={i} title={ele.title} img={ele.img} description={ele.description} lang={lang}/>))
                })}
            </div>
            <p>{content[lang].subHeader}</p>
            <button className={`${classes["glow-on"]} ${lang === 'ar'&&classes.ar_text}`} >
                <a href={path} className={classes["glow-on-link"]} >{content[lang].buttonText}<GrFormNextLink /></a>
            </button>
        </section>
    )
}

export default SubServPart